import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for Firebase Auth to determine the current session (restore from storage)
  await authService.waitForInit();

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to login page if unauthenticated
  return router.createUrlTree(['/login']);
};
